import { Button, ButtonGroup } from "@components/button";
import { IPrAtsrFormSectionOtherEmploymentRecordsEntity } from "@odata/GeneratedEntityTypes";
import { PrAnnualTaxSettlementRequestFormSectionDetailTypeCode } from "@odata/GeneratedEnums";
import { yearPath } from "@pages/payroll/annualTaxSettlementRequest/OtherEmploymentDialog.def";
import React from "react";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { Status, TextAlign } from "../../../enums";
import { IDialogFormViewProps } from "../../../views/formView/DialogFormView";
import { FormViewForExtend } from "../../../views/formView/FormView";

interface IProps extends IDialogFormViewProps<IPrAtsrFormSectionOtherEmploymentRecordsEntity> {
    hasAttachment?: boolean;
    year?: number;
    isReadOnly?: boolean;
}

class OtherEmploymentFormView extends FormViewForExtend<IPrAtsrFormSectionOtherEmploymentRecordsEntity, IProps> {
    onAfterLoad() {
        this.props.storage.setValueByPath(yearPath, this.props.year);
        return super.onAfterLoad();
    }

    onBeforeSave(entity?: IPrAtsrFormSectionOtherEmploymentRecordsEntity): IPrAtsrFormSectionOtherEmploymentRecordsEntity {
        entity.ChildDeductions?.forEach(deduction => {
            deduction.TypeCode = PrAnnualTaxSettlementRequestFormSectionDetailTypeCode.ChildDeduction;
        });

        entity.Ztps?.forEach(ztp => {
            ztp.TypeCode = PrAnnualTaxSettlementRequestFormSectionDetailTypeCode.ZTP;
        });

        return entity;
    }

    handleFieldsConfirm = async (): Promise<void> => {
        const { storage } = this.props;

        const validationRes = await storage.validateAll();

        if (!this.props.hasAttachment) {
            storage.setFormAlert({
                status: Status.Error,
                title: storage.t("Common:Validation.Required"),
                subTitle: storage.t("AnnualTaxSettlementRequest:Validation.MissingAttachment")
            });
            storage.refresh();
            return;
        }
        const data = this.onBeforeSave(storage.data.entity);

        if (!validationRes.hasError) {
            // this is false just if it's filled from employee dashboard,
            // where employee uploads only the attachment without filling other fields, currently not implemented case
            data.IsFilled = true;
            this.props.onAfterConfirm(data);
        } else {
            storage.refresh();
        }
    };

    renderFooter = () => {
        const { storage } = this.props;
        return (
            <ButtonGroup align={TextAlign.Right}>
                {!storage.isReadOnly &&
                    <Button onClick={this.handleFieldsConfirm}>{storage.t("Common:General.Save")}</Button>}
                {storage.isReadOnly &&
                    <Button onClick={this.props.onClose}>{storage.t("Common:General.Close")}</Button>}
            </ButtonGroup>
        );
    };
}

export default withPermissionContext(OtherEmploymentFormView);